import * as preact from "preact";
import * as hooks from "preact/hooks";

import * as modalController from "modalController";
import readlangClient from "readlangClient";
import Dialog from "views/Dialog";

type Props = {
  userID: string;
  onApplied: () => void;
};

/**
 * Admin grant of complimentary Premium or Premium Plus: extends the user's
 * active grant of the same plan, otherwise creates one.
 */
export default function ApplyPremiumDialog({ userID, onApplied }: Props) {
  const [plan, setPlan] = hooks.useState<"standard" | "plus">("standard");
  const [months, setMonths] = hooks.useState("");
  const [submitting, setSubmitting] = hooks.useState(false);
  const [error, setError] = hooks.useState<string | null>(null);

  const apply = async () => {
    setSubmitting(true);
    setError(null);
    try {
      await readlangClient.request("POST", `/api/user/${userID}/applyPremium`, {
        plan,
        months: parseInt(months, 10),
      });
    } catch (error: any) {
      // readlangClient rejections carry the response body at jqXHR.data (see
      // request() docs)
      setError(
        error.jqXHR?.alreadyNotified
          ? "Connection problem. Please try again."
          : error.jqXHR?.data?.errorMessage || "Failed to apply premium"
      );
      setSubmitting(false);
      return;
    }
    modalController.cancel();
    onApplied();
  };

  return (
    <Dialog
      heading="Apply Premium"
      error={error}
      actions={
        <button onClick={apply} disabled={submitting}>
          {submitting ? "Applying..." : "Apply"}
        </button>
      }
    >
      <p>
        <select
          value={plan}
          onChange={(event) =>
            setPlan(event.currentTarget.value as "standard" | "plus")
          }
        >
          <option value="standard">Premium</option>
          <option value="plus">Premium Plus</option>
        </select>{" "}
        for{" "}
        <input
          type="number"
          min="1"
          placeholder="months"
          value={months}
          onInput={(event) => setMonths(event.currentTarget.value)}
        />{" "}
        months
      </p>
    </Dialog>
  );
}
